var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconclose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#212543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7812 12.7812L17.0312 16.5312L20.75 20.25C21.0625 20.5312 21.0625 21 20.75 21.2812C20.4688 21.5938 20 21.5938 19.7188 21.2812L15.9688 17.5625L12.25 21.2812C11.9688 21.5938 11.5 21.5938 11.2188 21.2812C10.9062 21 10.9062 20.5312 11.2188 20.2188L14.9375 16.5L11.2188 12.7812C10.9062 12.5 10.9062 12.0312 11.2188 11.7188C11.5 11.4375 11.9688 11.4375 12.2812 11.7188L16 15.4688L19.7188 11.75C20 11.4375 20.4688 11.4375 20.7812 11.75C21.0625 12.0312 21.0625 12.5 20.7812 12.7812Z",
    fill: "#F1F5F9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconclose);
export default __webpack_public_path__ + "static/media/iconclose.b25abd295f94d129ee754d41a4a9dc11.svg";
export { ForwardRef as ReactComponent };